import moment from "moment/moment";
import { useNavigate, useParams } from "react-router-dom";
import Card from "components/Layout/Card";
import Loader from "components/Layout/Loader";
import { useSelector } from "react-redux";
import usePermission from "hooks/usePermission";
import { formatInboxTime } from "utils/helpers";

const NewList = ({
    isLoading,
    msgList,
    deleteIds,
    handelDeleteId,
    handelDeleteMessage,
    handelStarMessage,
    listType,
    isResourceMail = false,
    onOpenResourceMail = () => { },
}) => {

    const params = useParams();
    const navigate = useNavigate();
    const { userDetails } = useSelector((state) => ({
        userDetails: state.student.userDetails,
    }));
    const { memberType, type } = params;
    const redirectToEmailDetails = (id, key) => {
        {
            viewAccess === "1" &&
                navigate(`/${memberType}/inbox-notifications/${type}/${id}/${key}`);
        }
    };

    const { viewAccess, createAccess, updateAccess, deleteAccess } = usePermission("Inbox/Notifications");

    return (
        <>
            {isLoading ? (
                <>
                    <Card className="d-flex align-items-center justify-content-center cpt-50 cpb-50">
                        <Loader size="md" />
                    </Card>
                </>
            ) : msgList.length === 0 ? (
                <Card className="d-flex justify-content-center text-15-400 cpb-50 cpt-50 unset-br">
                    No Data Found
                </Card>
            ) : (
                <Card className="d-flex align-items-center cps-12 cpe-12 unset-br inbox-list-container pb-1 pt-1 fadeInUp">
                    <div className="w-100 inbox-list">

                        {msgList.map((elem, index) => {
                            const {
                                sender_detail = {},
                                receiver_detail = {},
                                subject,
                                id,
                                key,
                                created_at,
                                description
                            } = elem;
                            const cleanDescription = description
                                ?.replace(/<[^>]+>/g, "")
                                ?.replace(/\s+/g, " ")
                                ?.trim();

                            return (
                                <div key={index} className="border br-5 cmb-12 b-d1d1 cmt-10 cm-10" >

                                    <div
                                        className="color-1717 text-14-500-17  d-flex align-items-center justify-content-between pointer border-bottom cps-12 cpt-10 cpb-10 cpe-12"
                                        style={{ backgroundColor: "#F5F5FF" }}
                                        onClick={() => {
                                            if (isResourceMail) {
                                                onOpenResourceMail?.({ id, key });

                                            } else {
                                                redirectToEmailDetails(id, key);
                                            }
                                        }}
                                    >
                                        <div>
                                            {[
                                                receiver_detail?.name,
                                                receiver_detail?.abstract_id,
                                                receiver_detail?.paper_title
                                            ]
                                                .filter(Boolean)
                                                .join(" | ")}
                                        </div>

                                    </div>

                                    <div
                                        className="text-14-300-24 color-black-olive cps-14 cpt-18 cpb-14 d-flex justify-content-between"
                                        onClick={() => {
                                            if (isResourceMail) {
                                                onOpenResourceMail?.({ id, key });
                                            } else {
                                                redirectToEmailDetails(id, key);
                                            }
                                        }}
                                        style={{ cursor: "pointer" }}

                                    >
                                        <div
                                            className="d-flex"
                                            style={{
                                                maxWidth: "80%",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis"
                                            }}
                                        >
                                            {subject &&
                                                <span className="text-14-500-18 color-1717">{subject}{' '}</span>}
                                            {cleanDescription &&
                                                <span
                                                    className="text-14-300-18"
                                                    style={{
                                                        display: "inline-block",
                                                        maxWidth: "100%",
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis"
                                                    }}
                                                >
                                                    {" - "}{cleanDescription}
                                                </span>}
                                        </div>

                                        <span className="text-14-300-18 cpe-14">{formatInboxTime(created_at)}</span>
                                    </div>

                                </div>
                            );
                        })}

                    </div>
                </Card>
            )}
        </>
    );
};

export default NewList;
